import $ from 'jquery';
import Cookies from 'js-cookie';
import Clipboard from 'clipboard';

// Print the page
function printPage() {
    $('.print').on('click', (e) => {
        e.preventDefault();
        window.print();
    });
}

function copyText() {
    try {
        const clip = new Clipboard('.btn-copy');

        clip.on('success', (e) => {
            const $trigger = $(e.trigger);
            $trigger.attr('data-original-title', 'Copied to Clipboard!').tooltip('show');
            setTimeout(() => { $trigger.tooltip('hide'); }, 3000);
        });

        clip.on('error', (e) => {
            const $trigger = $(e.trigger);
            $trigger.attr('data-original-title', 'Copy with CTRL/CMD + C').tooltip('show');
            setTimeout(() => { $trigger.tooltip('hide'); }, 3000);
        });
    } catch (e) {
        $('.btn-copy').hide();
    }
}

// generate links to hashes for all headings in ark objects with ids, to be visible on hover for
// easy user reference/sharing sections of the document.
function createAnchors() {
    $('.region__title, .region__heading, .content__heading, .meta__label').each((i, el) => {
        const $el = $(el);
        const icon = '<i class="fa fa-link"></i><span class="sr-only">Bookmark this section</span>';
        const id = $el.attr('id');
        if (id) {
            return $el.append($('<a />', {
                class: 'anchor',
                id: `anchor-${id}`,
                href: `#${id}`,
                'aria-hidden': 'true',
                title: 'Update your browser\'s address bar to this ___location on the page.',
                'data-toggle': 'tooltip',
                tabindex: '-1',
            }).html(icon));
        }
    });

    $('a.anchor').on('click', function (e) {
        const hash = $(this).attr('href');
        e.preventDefault();
        history.___replaceState(null, null, hash);
    });
}

// create a toggler for grid/list based displays
function toggleColumns() {
    $('#toggle-list, #toggle-grid').on('click', function () {
        const $this = $(this);
        const $sibling = $this.siblings('button');
        const target = $this.attr('data-target');
        $this.hide();
        $sibling.show();
        $(target).toggleClass('col-lg-6 col-lg-12 stephen');
    });
}

// take a function, wrapped in a timeout, return the original with the timeout.
// Useful for maintaining original function if failure occurs in GA tracking.
function withTimeout(callback, wait) {
    let called = false;
    setTimeout(callback, wait || 1000);

    return function () {
        if (!called) {
            called = true;
            callback();
        }
    };
}


// Add pagination to any list with class 'list-group--paginated'.
// Pager element should be sibling element list classed 'list-group-pagination'
function addPagination() {
    $('.list-group--paginated').each(function () {
        const $listElement = $(this);
        const $listItems = $listElement.find('.list-group-item');
        const totalItems = $listItems.length;
        const itemsPerPage = 20;
        const totalPages = Math.ceil(totalItems / itemsPerPage);

        $(this).siblings('.list-group-pagination').twbsPagination({
            totalPages,
            visiblePages: 5,
            onPageClick(event, page) {
                if (totalPages < 2) {
                    $(this).addClass('hidden');
                } else {
                    const firstItem = (page - 1) * itemsPerPage;
                    const lastItem = page * itemsPerPage;
                    $listItems.addClass('hidden');
                    $listItems.slice(firstItem, lastItem).removeClass('hidden');
                }
            },
        });
    });
}

// Hide Alerts if a user clicks, or has clicked on a close button.
// Used to hide IE-related compatibility warnings, and other similar alerts.
function hideAlerts() {
    $(document).on('close.bs.alert', (e) => {
        const notAppeal = !$(e.target).hasClass('navbar--appeal');
        if (notAppeal) {
            const alertID = $(e.target).attr('id');
        Cookies.set(alertID, 'hidden', { expires: 30 });
        }
    });
}

// Hide appeal messages. Appeal message data is defined in the django project settings.
function hideAppealMessages() {
    const $nehAppeal = $('#appeal');
    if ($nehAppeal.length > 0) {
        const cookie = $nehAppeal.data('appeal-cookie');
        const expire = $nehAppeal.data('appeal-expire');
        const site = window.gaPrefix;
        const path = $nehAppeal.data('appeal-path');
        $('#dismiss-appeal').on('click', (event) => {
        event.preventDefault();
        $nehAppeal.fadeOut();
        Cookies.set('hiddenAppeal', cookie, { expires: expire, path: '/' });
    });
    }
}

export {
    printPage,
    copyText,
    createAnchors,
    toggleColumns,
    addPagination,
    hideAlerts,
    hideAppealMessages,
    withTimeout,
};
